import { Private, Business } from 'types/customer'

export const CUSTOMER_TYPES: {
  private: Private
  business: Business
} = {
  private: 'private',
  business: 'business',
}
